import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useEffect, useState } from "react";

const quoteCart = "quoteCart";

type QuoteCartType = {
    quoteCount: number;
    products: ProductModel[];
    productsIds: string[];
};

const initialState: QuoteCartType = {
    quoteCount: 0,
    products: [],
    productsIds: [],
};

const useQuoteCartProduct = (quoteCount=0) => {
    const [cart, setCart] = useState<QuoteCartType>(initialState);

    useEffect(() => {
        getCartFromLocalStorage();
    }, [quoteCount]);

    const getLocalParsedCart = () => {
        const qCart = localStorage.getItem(quoteCart);
        if (qCart) {
            return JSON.parse(qCart) as QuoteCartType;
        }

        localStorage.setItem(quoteCart, JSON.stringify(cart));
        return cart;
    };

    const getCartFromLocalStorage = () => {
        const qCart = getLocalParsedCart();
        setCart(qCart);
    };

    const setCartToLocalStorage = (product: ProductModel) => {
        const parsedQCart = getLocalParsedCart();
        parsedQCart.products.push(product);
        parsedQCart.productsIds.push(product.id);
        parsedQCart.quoteCount = parsedQCart.quoteCount + 1;
        setCart(parsedQCart);
        localStorage.setItem(quoteCart, JSON.stringify(parsedQCart));
    };

    const deleteFromLocalStorage = (id: string) => {
        const parsedQCart = getLocalParsedCart();
        const isProductExist = parsedQCart.productsIds.includes(id);
        if (isProductExist) {
            parsedQCart.products = parsedQCart.products.filter(pro => pro.id !== id);
            parsedQCart.quoteCount = parsedQCart.quoteCount - 1;
            parsedQCart.productsIds = parsedQCart.productsIds.filter(ids => ids !== id);
            setCart(parsedQCart);
            localStorage.setItem(quoteCart, JSON.stringify(parsedQCart));
        }
    };

    const removeQuoteCartFromLocalStorage = () => {
        localStorage.removeItem(quoteCart);
        setCart(initialState);
    };

    return { cart, setCartToLocalStorage, deleteFromLocalStorage, removeQuoteCartFromLocalStorage };
};

export default useQuoteCartProduct;
